import { SECONDS_PER_MINUTE } from '@saviynt/common';

import { msgs } from '../../utilities/messages';
// Objects
export const MODAL_PAGE_KINDS = { COC: 'coc', CTS: 'cts', COR: 'cor' };
export const ACCOUNT_JIT_SELECTION = {
  value: 'JIT',
  title: 'Temporary Privileged Account',
  description:
    'Create a new one-time-use account for Just-in-Time (JIT) access.',
  maxtime: '36000',
};
export const SESSION_STATUSES = {
  PENDING: undefined,
  APPROVED: 1,
  APPROVED_ACTIVE: 2,
  COMPLETED: 3,
};
export const ASSET_TYPES = {
  ACCOUNT: 'Account',
  APPLICATION: 'Application',
  DATABASE: 'Database',
  SERVER: 'Server',
  CONSOLE: 'Console',
};
export const PLATFORM_TYPES = {
  AD: 'Active Directory',
  AWS: 'AWS',
  AZURE: 'Azure',
  AZURE_AD: 'AzureAD',
  GCP: 'GCP',
  OKTA: 'Okta',
  ON_PREMISE: 'On-Premise',
  SALESFORCE: 'Salesforce',
  SAP: 'SAP',
  VAULT: 'Vault',
};
export const INTERVALS = {
  MINUTES: 'minutes',
  HOURS: 'hours',
  DAYS: 'days',
};
export const DURATION_TAB_TYPES = {
  NOW: 'NOW',
  FUTURE: 'FUTURE',
};

// Single Values
// TODO: Update this with NOW duration leap year criteria information
export const OFFSET_SECONDS_PER_YEAR = 31104000;
export const MIN_LENGTH_FOR_JUSTIFICATION = 3;
export const MAX_LENGTH_FOR_JUSTIFICATION = 1000;
export const MAX_LENGTH_FOR_TICKET_NUMBER = 50;
export const MAX_ACCOUNTS_BEFORE_SPLICE = 5;
export const DEFAULT_USER_MAX_TIME = 36000;
export const MAX_RADIO_OPTIONS_TO_SHOW = 6;
export const INTERVAL_LENGTH_IN_MINS = 15;
export const BYTES_PER_MB = 1024 * 1024;
export const MAX_APPS_BEFORE_SPLICE = 5;
export const MAX_ACCOUNTS_TO_SHOW = 6;
export const AVG_DAYS_PER_MONTH = 30;
export const MIN_TARGET_LENGTH = 5;
export const MAX_APPS_TO_SHOW = 6;
export const MINUTE_INTERVAL = 15;
export const MIN_PORT_LENGTH = 4;

// Initial State Objects
export const initialCriticalState = {
  accountId: false,
  appSelection: false,
  startdate: false,
  enddate: false,
  tCodeSelection: false,
  isDurationBeingEdited: false,
};
export const initialAccordionSnapshotState = {
  isNowTab: true,
  isDurationCustom: false,
  customDurationInputValue: '',
  checkedIntervalOption: INTERVALS.MINUTES,
  futureTabStartDate: null,
  futureTabEndDate: null,
  durationChipValue: null,
};

// Initial State Arrays - Functions that return localized options
export const getInitialIntervalOptions = (localize) => [
  {
    label: localize(msgs.pam.modalPage.intervals.minutes),
    value: INTERVALS.MINUTES,
    isChecked: true,
  },
  {
    label: localize(msgs.pam.modalPage.intervals.hours),
    value: INTERVALS.HOURS,
  },
  {
    label: localize(msgs.pam.modalPage.intervals.days),
    value: INTERVALS.DAYS,
  },
];

export const getChipOptions = (localize) => [
  {
    value: 30 * SECONDS_PER_MINUTE,
    label: localize(msgs.pam.modalPage.chipOptions.thirtyMin),
  },
  {
    value: 60 * SECONDS_PER_MINUTE,
    label: localize(msgs.pam.modalPage.chipOptions.oneHour),
  },
  {
    value: 120 * SECONDS_PER_MINUTE,
    label: localize(msgs.pam.modalPage.chipOptions.twoHours),
  },
  {
    value: 240 * SECONDS_PER_MINUTE,
    label: localize(msgs.pam.modalPage.chipOptions.fourHours),
  },
  {
    value: 480 * SECONDS_PER_MINUTE,
    label: localize(msgs.pam.modalPage.chipOptions.eightHours),
  },
];
